<template>
	<div class="questioin-wrap">
		<CFullEmpty v-if="emptyData" />
		<template v-else-if="tabOption.length">
			<CTabs v-model="activeTab" :option="tabOption" :ellipsis="false" @change="changeActive" v-if="showTabs" />
			<div class="scroll-wrap" v-for="(item, index) in tabOption" :key="index" v-show="activeTab == index">
				<CScrollPro
					ref="scrollRef"
					pullDown
					@pull-down="scrollPullDown"
					pullUp
					:moreData="listData[index].hasMore"
					@pull-up="scrollPullUp"
					contentClassName="act-scroll-box"
				>
					<div class="item-wrap" v-if="listData[index].list.length">
						<CCardQaPanelWithoutHHMM
							v-for="(item, idx) in listData[index].list"
							:key="idx"
							:item="item"
							:border="idx != listData[index].list.length - 1"
						></CCardQaPanelWithoutHHMM>
					</div>
					<m-visible-tips v-if="!listData[index].hasMore" />
				</CScrollPro>
			</div>
			<CFullEmpty v-if="listData[activeTab].isEmpty" />
		</template>
	</div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import CTabs from '@rebuild/components/CTabs.vue';
import CScrollPro from '@rebuild/components/CScrollPro.vue';
import CCardQaPanelWithoutHHMM from '@rebuild/materials/shared/question/CCardQaPanelWithoutHHMM.vue';
import CFullEmpty from '@rebuild/components/CFullEmpty.vue';
import { useQuestionConfigData } from '@rebuild/materials/shared/question/useQuestionConfigData';
import { useQuestionModuleData } from '@rebuild/materials/shared/question/useQuestionModuleData';

const { loadQuestionTabs } = useQuestionConfigData();
const { fetchQuestionList } = useQuestionModuleData();

const listData = ref([]);
const activeTab = ref(0);
const tabOption = ref([]);
const emptyData = ref(false);
const scrollRef = ref(null);

const showTabs = computed(() => {
	if (tabOption.value.length <= 1) return false;
	return true;
});

const changeActive = idx => {
	activeTab.value = idx;

	const pickRef = scrollRef.value[activeTab.value];
	pickRef && pickRef.init();

	if (listData.value[idx].list.length == 0) {
		loadData(true);
	}
};

const initCardTabs = async () => {
	const tabs = await loadQuestionTabs();
	let tabMap = tabs.map(item => ({ label: item.name, value: item.value || '' }));
	tabOption.value = tabMap.map(item => item.label);
	tabMap.forEach(item => {
		listData.value.push({
			list: [],
			pagestart: 0,
			hasMore: true,
			sourceBiz: item.value || '',
			isEmpty: false
		});
	});
};

const loadData = async (reload = false) => {
	let _activeTab = activeTab.value;
	const result = await fetchQuestionList({
		sourceBiz: listData.value[_activeTab].sourceBiz,
		pagestart: listData.value[_activeTab].pagestart,
		pagenum: 20
	});

	const rows = result.rows;
	const total = result.total;
	let target = listData.value[_activeTab];
	if (reload) {
		target.list = rows;
	} else {
		let arr = target.list.concat(rows);
		target.list = arr;
	}
	target.hasMore = listData.value[_activeTab].list.length < total;
	target.isEmpty = !total;
	listData.value[_activeTab] = target;
};

const scrollPullDown = async done => {
	setPageStart('pullDown');
	await loadData(true);
	done();
};

const scrollPullUp = async done => {
	setPageStart('pullUp');
	await loadData();
	done();
};

const setPageStart = type => {
	let _activeTab = activeTab.value;
	let target = listData.value[_activeTab];
	type == 'pullDown' ? (target.pagestart = 0) : target.pagestart++;
	listData.value[_activeTab] = target;
};

onMounted(async () => {
	await initCardTabs();
	if (listData.value.length) {
		loadData(true);
	}
});
</script>

<style lang="less" scoped>
.questioin-wrap {
	display: flex;
	flex-direction: column;
	height: 100%;
	background: #fff;
	.scroll-wrap {
		flex: 1;
		height: 0;
	}
	.item-wrap {
		padding: 0.14rem;
		.item {
			margin-bottom: 0.14rem;
			&--question {
				.title {
					color: #333;
					font-size: 0.15rem;
					font-weight: 500;
					line-height: 140%; /* 21px */
				}
			}
			&--answer {
				margin-top: 0.08rem;
				padding: 0.1rem;
				font-size: 0.14rem;
				font-weight: 400;
				line-height: 140%; /* 19.6px */
				color: #666;
				border-radius: 0.06rem;
				background: #f7f8fa;
			}
			&--time {
				padding: 0.08rem 0 0.14rem;
				display: flex;
				justify-content: space-between;
				align-items: center;
				color: var(---Text-4, #c5c5c5);
				font-size: 0.11rem;
				font-weight: 400;
				line-height: 0.15rem; /* 136.364% */
			}
			&:not(:last-child) {
				border-bottom: 1px solid #e8eaef;
			}
		}
	}
}
</style>
